<dynamic-form
  *ngIf="columns && columns.length > 0 && isOk4Load"
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [model]="model"
  [areaName]="areaName"
  [hasDefault]="false"
  [columns]="columns"
  (valueChange)="valueChange()"
  [erroremessage]="erroremessage"
  [noSubmit]="deactivateSave"
  hasfocus="FirstName"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="fcContent">
    <div class="box alighnheader">
      <ssg-select
        *ngIf="isNewRow"
        name="PartyId"
        [group]="formGroup"
        [label]="'ClientApp.FrontOffice.Parties.Personnel.PartyId' | translate"
        userClass="select-sm"
        apiName="Customer/GetPagining"
        valueFieldName="PartyId"
        textColumnsName="DisplayName,Number,PhoneNumber"
        filterKey="Party.Number,Party.FirstName,Party.LastName"
        [columnsTitleName]="'ClientApp.FrontOffice.Parties.Personnel.CodePhone' | translate"
        [isMultiColumns]="true"
        textFieldName="DisplayName"
        SortColumn="Party.Number"
        isMultiColumns="true"
        IsEqual="true"
        [hasDefault]="false"
        (valueChange)="PartyAccountChange($event)">
      </ssg-select>
      <ssg-input
        *ngIf="!isNewRow"
        name="DisplayName"
        [label]="'ClientApp.FrontOffice.Parties.Personnel.DisplayName' | translate"
        [group]="formGroup"
        userClass="select-sm"
        required="false"
        disabled="true"
        textType="text">
      </ssg-input>
      <ng-container *ngIf="rolesIsLodes">
        <ssg-select
          name="RolesId"
          [multiple]="true"
          [group]="formGroup"
          [label]="'ClientApp.FrontOffice.Parties.Personnel.Roles' | translate"
          userClass="select-sm"
          class="personnel-role"
          apiName="Lookup"
          textFieldName="Title"
          valueFieldName="Id"
          systemName="SALE"
          [required]="true"
          category="PersonnelRoles"
          (valueChange)="ChangeRoles($event)">
        </ssg-select>
      </ng-container>
      <ssg-select
        name="UserId"
        [group]="formGroup"
        [dataList]="UserList"
        [label]="'ClientApp.FrontOffice.Parties.Personnel.UserList' | translate"
        userClass="select-sm"
        textFieldName="Title"
        valueFieldName="Id"
        (valueChange)="CreditControlTypeChange($event)"
        valueFieldName="Id">
      </ssg-select>
      <ng-container>
        <input #uploadInput (change)="openImageUpload($event)" type="file" accept="image/png/jpeg/jpg" class="d-none" />
        <ssg-button
          (click)="uploadInput.click()"
          class="upload-btn"
          [label]="'ClientApp.FrontOffice.Parties.Personnel.UploadImage' | translate"></ssg-button>
        <div class="personnel-img">
          <img [src]="model.Image" alt="" />
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-container class="content">
    <ssg-tabset class="tabcontentbox" class="tabcontainer tabcontentbox">
      <ssg-tab *ngIf="isAccessToAllBranches" [tabTitle]="'ClientApp.FrontOffice.Parties.Personnel.Branches' | translate">
        <editable-grid
          *ngIf="Branches.length > 0 && model?.Branches?.length > 0 && showBranch"
          [DefaultValues]="DefaultValues"
          [columns]="Branches"
          [dataList]="model.Branches"
          [isAdd]="false"
          [isDelete]="false">
        </editable-grid>
      </ssg-tab>
      <ssg-tab *ngIf="isSelectedDriverRoles" [tabTitle]="'ClientApp.FrontOffice.Parties.Personnel.DeliveryMan' | translate">
        <div class="row detail">
          <div class="col-lg-4">
            <ssg-input
              name="VehiclePlateNumber"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.VehiclePlateNumber' | translate"
              [group]="formGroup"
              required="false"
              textType="text"
              maxLength="20">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="LicenseNumber"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.LicenseNumber' | translate"
              [group]="formGroup"
              required="false"
              textType="text"
              maxLength="20">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <date-picker
              id="dpLicenseExpirationDate"
              name="LicenseExpirationDate"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.LicenseExpireDate' | translate"
              required="false"
              textType="date"
              disabled="false">
            </date-picker>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="InsuranceNumber"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.InsuranceNumber' | translate"
              [group]="formGroup"
              required="false"
              textType="text"
              maxLength="20">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="VehicleVinCode"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.VehicleVinCode' | translate"
              [group]="formGroup"
              required="false"
              textType="text"
              maxLength="20">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="NationalCode"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.NationalCode' | translate"
              [group]="formGroup"
              required="false"
              textType="text"
              maxLength="20">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="VehicleColor"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.VehicleColor' | translate"
              [group]="formGroup"
              required="false"
              textType="text"
              maxLength="20">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="VehicleCapacity"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.VehicleCapacity' | translate"
              [group]="formGroup"
              required="false"
              textType="text"
              maxLength="20">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="VehicleEngineVolume"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.VehicleEngineVolume' | translate"
              [group]="formGroup"
              required="false"
              textType="text"
              maxLength="20">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="VehicleEngineCode"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.VehicleEngineCode' | translate"
              [group]="formGroup"
              required="false"
              textType="text"
              maxLength="20">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="VehicleChassisCode"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.VehicleChassisCode' | translate"
              [group]="formGroup"
              required="false"
              textType="text"
              maxLength="20">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <date-picker
              id="dpInsuranceExpirationDate"
              name="InsuranceExpirationDate"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.InsuranceExpireDate' | translate"
              required="false"
              textType="date"
              disabled="false">
            </date-picker>
          </div>
          <div class="col-lg-4">
            <ssg-checkbox
              id="chbHasCredit"
              name="HasCredit"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.IsCreditDeliveryMan' | translate"
              required="false"
              disabled="false"
              (valueChange)="CreditCourierChange($event)">
            </ssg-checkbox>
          </div>
          <div class="col-lg-4" *ngIf="hasCredit">
            <ssg-select
              name="CreditControlTypeId"
              [label]="'ClientApp.FrontOffice.Parties.Customer.CreditControlKind' | translate"
              apiName="Lookup"
              [group]="formGroup"
              systemName="SALE"
              category="CreditControlType"
              required="false"
              textFieldName="Title"
              valueFieldName="Id"
              (valueChange)="CreditControlTypeChange($event)"
              [disabled]="!hasCredit">
            </ssg-select>
          </div>
          <div class="col-lg-4" *ngIf="hasCredit">
            <ssg-input
              name="CreditLimit"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.MaxCredit' | translate"
              [group]="formGroup"
              max="10000000000000000"
              min="0"
              required="false"
              textType="currency"
              [withComma]="true"
              (valueChange)="CreditControlTypeChange($event)"
              [disabled]="!hasCredit">
            </ssg-input>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.Parties.Customer.Details' | translate">
        <div class="row detail">
          <div class="col-lg-4">
            <ssg-input
              name="HealthNumber"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.HealthNumber' | translate"
              [group]="formGroup"
              required="false"
              textType="text"
              maxLength="11">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <date-picker
              id="dpHealthExpirationDate"
              name="HealthExpirationDate"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.HealthExpireDate' | translate"
              required="false"
              textType="date"
              disabled="false">
            </date-picker>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="Introducer"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.Introducer' | translate"
              [group]="formGroup"
              required="false"
              textType="text">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <ssg-select
              name="BailTypeId"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.BailType' | translate"
              apiName="Lookup"
              [group]="formGroup"
              systemName="SALE"
              category="BailType"
              required="false"
              textFieldName="Title"
              valueFieldName="Id"
              (valueChange)="ChangeBailPrice($event)">
            </ssg-select>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="BailPrice"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.BailPrice' | translate"
              [group]="formGroup"
              [disabled]="disabledBailPrice"
              textType="number"
              [max]="9999999999">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <ssg-select
              name="Documents"
              [multiple]="true"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.DocumentType' | translate"
              apiName="Lookup"
              textFieldName="Title"
              valueFieldName="Id"
              systemName="SALE"
              category="DocumentTypes">
            </ssg-select>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="TerminalNumber"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.TerminalNumber' | translate"
              [group]="formGroup"
              required="false"
              textType="text">
            </ssg-input>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab *ngIf="isSelectedWaiterRoles" [tabTitle]="'ClientApp.FrontOffice.Parties.Personnel.Waiter' | translate">
        <div class="row detail">
          <div class="col-lg-4">
            <ssg-select
              name="DefaultSalonId"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.DefaultSalon' | translate"
              apiName="Salon/PersonnelReadLookup"
              [group]="formGroup"
              required="false"
              textFieldName="Title"
              valueFieldName="Id">
            </ssg-select>
          </div>
          <div class="col-lg-4">
            <ssg-checkbox
              id="chbCanUseOtherTable"
              name="CanUseOtherTable"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Parties.Personnel.CanUseOtherTable' | translate"
              required="false"
              disabled="false">
            </ssg-checkbox>
          </div>
        </div>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
